import { h } from 'preact';
import GMapCustomMarker from 'components/shared/gmap/customMarker.js';
import { removeClass } from 'utils/utils';
import s from 'components/shared/maptiler/customMarker.sss';

export default class CustomMarker extends GMapCustomMarker {
	constructor(props) {
		super(props);
		this.s = s;
	}

	updateLatLng(props = this.props) {
		this.latlng = props.latlng;
		if (!this.latlng && props.geo) {
			this.latlng = [props.geo.lon, props.geo.lat];
		}
	}

	mount() {
		if (this.mounted || this.props.isStatic || !this.dom || !window.mapboxgl) {
			return;
		}
		this.mounted = true;

		this.currentDom = this.dom.cloneNode(true);
		removeClass(this.currentDom, s.hidden);

		const dom = this.dom.cloneNode(true);
		removeClass(dom, s.hidden);

		let element = document.createElement('div');
		element.className = s.outer;
		element.appendChild(dom);
		this.marker = new window.mapboxgl.Marker({
			element,
			anchor: this.props.bottomAnchor ? 'bottom' : 'center'
		}).setLngLat(this.latlng).addTo(this.props.map);

		this.markerDom = dom;

		this.addListeners();

		this.onMap = true;
	}

	addListeners() {
		this.markerDom.addEventListener('mousedown', this.mousedown);
		this.markerDom.addEventListener('touchstart', this.mousedown, { passive: true });
	}
	removeListeners() {
		if (this.markerDom) {
			this.markerDom.removeEventListener('mousedown', this.mousedown);
			this.markerDom.removeEventListener('touchstart', this.mousedown);
		}
	}

	add() {
		if (this.marker && !this.onMap) {
			this.marker.addTo(this.props.map);
		}
		this.onMap = true;
	}

	remove() {
		if (this.marker && this.onMap) {
			this.marker.remove();
		}
		this.onMap = false;
	}

	refresh() {
		if (!this.marker) return;
		this.marker.remove();
		if (this.onMap) {
			this.marker.addTo(this.props.map);
		}
	}

	draw() {}
}
